module.exports = __webpack_public_path__ + "img/undraw_done_a34v.330718c9.svg";